import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import tableDragScroll from '@/utils/tableDragScroll'

import '@/icons' // icon
import '@/permission' // permission control
import '@/utils/initial' // 全局方法
Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.directive('tableDragScroll', tableDragScroll)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js